import * as React from "react";
const ClockWhite = (props) => (
  <svg
    width={15}
    height={15}
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect x={0.5} y={0.5} width={14} height={14} rx={7} stroke="white" />
    <path
      d="M9.7407 9.42055L7.86829 8.30314C7.54213 8.10986 7.27637 7.64478 7.27637 7.26426V4.78784"
      stroke="white"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default ClockWhite;
